import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const FilteringIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V6.67157C22 7.46722 21.6839 8.23029 21.1213 8.79289L15.7929 14.1213C15.6054 14.3089 15.5 14.5632 15.5 14.8284V19C15.5 19.4089 15.251 19.7766 14.8714 19.9285L9.87139 21.9285C9.5633 22.0517 9.21414 22.0141 8.93937 21.8281C8.6646 21.642 8.5 21.3318 8.5 21V14.8284C8.5 14.5632 8.39464 14.3089 8.20711 14.1213L2.87868 8.79289C2.31607 8.23028 2 7.46722 2 6.67157V4ZM20 4H4V6.67157C4 6.93679 4.10536 7.19114 4.29289 7.37868L9.62132 12.7071C10.1839 13.2697 10.5 14.0328 10.5 14.8284V19.523L13.5 18.323V14.8284C13.5 14.0328 13.8161 13.2697 14.3787 12.7071L19.7071 7.37868C19.8946 7.19114 20 6.93679 20 6.67157V4Z"
    fill="currentColor"
  />,
  "FilteringIcon"
);
